<template>

</template>

<script>
export default {
    name: "VError"
}
</script>

<style scoped>

</style>